import { supabase } from '../lib/supabase';

// Get all email templates
export const getEmailTemplates = async () => {
  try {
    const { data, error } = await supabase
      .from('email_templates')
      .select('*')
      .order('template_type', { ascending: true });

    if (error) throw error;
    return data || [];
  } catch (error) {
    console.error('Error fetching email templates:', error);
    throw error;
  }
};

// Get a specific template by type (returns null if not found, so caller can use defaults)
export const getEmailTemplate = async (templateType) => {
  try {
    const { data, error } = await supabase
      .from('email_templates')
      .select('*')
      .eq('template_type', templateType)
      .maybeSingle();

    if (error) throw error;
    return data;
  } catch (error) {
    console.error('Error fetching email template:', error);
    throw error;
  }
};

// Create or update an email template
export const saveEmailTemplate = async (templateData) => {
  try {
    // Check if template exists
    const { data: existing } = await supabase
      .from('email_templates')
      .select('id')
      .eq('template_type', templateData.template_type)
      .single();

    if (existing) {
      // Update existing template
      const { data, error } = await supabase
        .from('email_templates')
        .update({
          subject: templateData.subject,
          body: templateData.body,
          updated_at: new Date().toISOString(),
        })
        .eq('id', existing.id)
        .select()
        .single();

      if (error) throw error;
      return data;
    } else {
      // Create new template
      const { data, error } = await supabase
        .from('email_templates')
        .insert([templateData])
        .select()
        .single();

      if (error) throw error;
      return data;
    }
  } catch (error) {
    console.error('Error saving email template:', error);
    throw error;
  }
};

// Get default templates (used if no custom template exists)
export const getDefaultTemplates = () => {
  // eslint-disable-next-line no-template-curly-in-string
  const estimateBody = 'Dear {{client_name}},\n\nPlease find attached your estimate {{invoice_number}}.\n{{total_amount_section}}\nIf you have any questions, please don\'t hesitate to contact us.\n\nBest regards,\nMenlo Atherton Glass';
  // eslint-disable-next-line no-template-curly-in-string
  const unpaidInvoiceBody = 'Dear {{client_name}},\n\nThis is a reminder that your invoice {{invoice_number}} is currently unpaid.\n\n{{total_amount_section}}{{due_date_section}}Please remit payment at your earliest convenience.\n\nIf you have any questions, please don\'t hesitate to contact us.\n\nBest regards,\nMenlo Atherton Glass';
  // eslint-disable-next-line no-template-curly-in-string
  const receiptBody = 'Dear {{client_name}},\n\nPlease find attached your receipt {{invoice_number}}.\n\n{{total_amount_section}}{{payment_method_section}}{{card_number_section}}{{due_date_section}}Thank you for your business!\n\nIf you have any questions, please don\'t hesitate to contact us.\n\nBest regards,\nMenlo Atherton Glass';
  
  return {
    estimate: {
      template_type: 'estimate',
      subject: 'Estimate {{invoice_number}} from Menlo Atherton Glass',
      body: estimateBody,
    },
    unpaid_invoice: {
      template_type: 'unpaid_invoice',
      subject: 'Reminder: Unpaid Invoice {{invoice_number}} from Menlo Atherton Glass',
      body: unpaidInvoiceBody,
    },
    invoice: {
      template_type: 'invoice',
      subject: 'Receipt {{invoice_number}} from Menlo Atherton Glass',
      body: receiptBody,
    },
  };
};
